import React, { FC }    from "react";
import { useDispatch }  from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import Staff            from "../../../domain/staff/Staff";
import StaffRepository  from "../../../domain/staff/StaffRepository";
import StaffDataSource  from "../../../infrastructure/datasource/staff/StaffDataSource";
import RouterDispatcher from "../../../infrastructure/redux/router/RouterDispatcher";

interface Props {
  staff: Staff;
}

const StaffEditButton: FC<Props> = (props: Props) => {
  const repository: StaffRepository = new StaffDataSource(useDispatch());
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          repository.setStaff(props.staff);
          routerDispatcher.staffEdit();
        } }
      >
        <Icon name="edit"/>編集する
      </Button>
    </>
  );
};

export default StaffEditButton;
